import { AccountsState, Account } from './store'
import { RequestState } from '../../types'

export const LOAD_ACCOUNTS_REQUEST = 'LOAD_ACCOUNTS_REQUEST'
export const LOAD_ACCOUNTS_RECEIVED = 'LOAD_ACCOUNTS_RECEIVED'
export const LOAD_ACCOUNTS_ERROR = 'LOAD_ACCOUNTS_ERROR'
export const LOAD_ACCOUNT_FILTERS_REQUEST = 'LOAD_ACCOUNT_FILTERS_REQUEST'
export const LOAD_ACCOUNT_FILTERS_RECEIVED = 'LOAD_ACCOUNT_FILTERS_RECEIVED'
export const LOAD_ACCOUNT_FILTERS_ERROR = 'LOAD_ACCOUNT_FILTERS_ERROR'

export type AccountsAction =
  | { type: typeof LOAD_ACCOUNTS_REQUEST, page: number }
  | { type: typeof LOAD_ACCOUNTS_RECEIVED, accounts: Account[], totalPages: number, page: number, totalCount: number }
  | { type: typeof LOAD_ACCOUNTS_ERROR, error: Error }
  | { type: typeof LOAD_ACCOUNT_FILTERS_REQUEST, accountId: string }
  | { type: typeof LOAD_ACCOUNT_FILTERS_RECEIVED, accountId: string, filters: any }
  | { type: typeof LOAD_ACCOUNT_FILTERS_ERROR, accountId: string, error: Error }

export function accountsReducer(state: AccountsState, action: AccountsAction) {
  switch (action.type) {
    case LOAD_ACCOUNTS_REQUEST: {
      if (action.page === 1) {
        return {
          ...state,
          requestState: RequestState.Loading,
          accounts: [],
          loadedPages: 0,
          totalCount: 0
        }
      } else {
        return {
          ...state,
          requestState: RequestState.Loading
        }
      }
    }

    case LOAD_ACCOUNTS_RECEIVED: {
      const newAccounts =
        action.page === 1 ? [...action.accounts] : state.accounts.concat(action.accounts)

      return {
        ...state,
        accounts: newAccounts,        
        requestState: RequestState.Loaded,
        loadedPages: action.page,
        totalPages: action.totalPages,
        totalCount: action.totalCount
      }
    }

    case LOAD_ACCOUNTS_ERROR: {
      return {
        ...state,
        requestState: RequestState.Error
      }
    }

    case LOAD_ACCOUNT_FILTERS_REQUEST: {
      return {
        ...state,
        accounts: state.accounts.map((account: any) => {
          if (account.id === action.accountId) {
            return {
              ...account,
              requestState: RequestState.Loading
            }
          } else {
            return account
          }
        })
      }
    }

    case LOAD_ACCOUNT_FILTERS_RECEIVED: {
      return {
        ...state,
        accounts: state.accounts.map((account: Account) => {
          if (account.id === action.accountId) {
            return {
              ...account,
              requestState: RequestState.Loaded,
              filters: action.filters
            }
          } else {
            return account
          }
        })
      }
    }

    case LOAD_ACCOUNT_FILTERS_ERROR: {
      return {
        ...state,
        accounts: state.accounts.map((account: Account) => {
          if (account.id === action.accountId) {
            return {
              ...account,
              requestState: RequestState.Error
            }
          } else {
            return account
          }
        })
      }
    }

    default: {
      return state
    }
  }
}

